<p-tabView>
    <p-tabPanel header="Qty Bucket Type">
      <p-table [value]="allQty" dataKey="id">
        <ng-template pTemplate="header">
          <tr>
            <th>Name</th>
            <th>Abbrevation</th>
            <th>Type</th>
            <th>Is Active</th>
            <th>Action</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-product>
          <tr>
            <td>{{product.name}}</td>
            <td>{{product.abbrevation}}</td>
            <td>{{product.type.name}}</td>
            <td>
              <span *ngIf="product.isActive == false">No</span>
              <span *ngIf="product.isActive == true">Yes</span>
            </td>
            <td class="action">
              <span class="btnBars p-mr-0" pTooltip="Edit" tooltipPosition="top" (click)="showEditQty(product)">
                <i class="pi pi-pencil"></i></span>
              <span class="btnBars p-mr-0" pTooltip="Delete" (click)="delQty(product)" tooltipPosition="top"><i
                  class="pi pi-trash"></i></span>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </p-tabPanel>
    <p-tabPanel header="Bucket Definition">
      <p-table [value]="allQty" dataKey="id">
        <ng-template pTemplate="header">
          <tr>
            <th>Name</th>
            <th>Abbrevation</th>
            <th>Definition</th>
            <th>Description</th>
            <th>Action</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-product>
          <tr>
            <td>{{product.name}}</td>
            <td>{{product.abbrevation}}</td>
            <td>{{product.definition}}</td>
            <td>
              <span pTooltip="{{product.description}}" tooltipPosition="top" class="pi pi-info-circle"
                [ngStyle]="{'color': (product.name=='To Location') ? '#6ab0c5' : ((product.name=='In Location') ? '#feca8b' : '#6ad2af') }"></span>
            </td>
            <td class="action">
              <span class="btnBars p-mr-0" pTooltip="Edit" tooltipPosition="top" (click)="showEditQty(product)">
                <i class="pi pi-pencil"></i></span>
              <span class="btnBars p-mr-0" pTooltip="Delete" (click)="delQty(product)" tooltipPosition="top"><i
                  class="pi pi-trash"></i></span>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </p-tabPanel>
    <p-tabPanel [disabled]="true" headerStyleClass="iconPanel">
      <ng-template pTemplate="header">
        <p-menu #configmenuQuantity id="config_menu_quantity" [model]="configMenuQuantityItems" [popup]="true"
          appendTo="body">
        </p-menu>
        <span class="btnBars p-mr-0" (click)="configmenuQuantity.toggle($event)">
          <i class="pi pi-bars"></i>
        </span>
      </ng-template>
    </p-tabPanel>
  </p-tabView>


  <!-- Inventory -->
  <p-dialog header="{{addEditQtyHeader}}" [modal]="true" [(visible)]="displayAddQty" [style]="{width: '50vw'}"
    [baseZIndex]="10000">
    <div class="header">
      <h5>Qty Information
        <p-inputSwitch class="header-switch" [(ngModel)]="tempQty.isActive"></p-inputSwitch>
      </h5>
    </div>
    <div class="card">
      <div class="p-grid">
        <div class="p-col-12 p-md-6">
          <label>Name</label>
          <input type="text" pInputText name="qtyName" [(ngModel)]="tempQty.name">
        </div>
        <div class="p-col-12 p-md-6">
          <label>Type</label>
          <p-dropdown appendTo="body" [options]="qtyTypes" optionLabel="name"
            [ngModelOptions]="{standalone: true}" [(ngModel)]="selectedQtyType"></p-dropdown>
        </div>
      </div>
      <div class="p-grid">
        <div class="p-col-12">
          <label>Description</label>
          <textarea pInputTextarea name="description" [rows]="3" [(ngModel)]="tempQty.description"></textarea>
        </div>
      </div>
    </div>
    <ng-template pTemplate="footer">
      <button pButton (click)="displayAddQty=false;" label="Cancel" class="p-button-secondary"></button>
      <button pButton (click)="saveQty(tempQty)" label="Save"></button>
    </ng-template>
  </p-dialog>
  <p-dialog header="{{addEditQtyItemHeader}}" [modal]="true" [(visible)]="displayAddQtyItem" [style]="{width: '50vw'}"
    [baseZIndex]="10000">
    <div class="header" *ngIf="addEditQtyItemHeader == 'Add Qty Item'">
      <h5>Qty Item Information
        <p-inputSwitch class="header-switch" [(ngModel)]="tempQtyItem.isActive"></p-inputSwitch>
      </h5>
    </div>
    <div class="header" *ngIf="addEditQtyItemHeader == 'Edit Qty Item'">
      <h5>{{tempQtyItem.name}} ({{tempQtyItem.abbrevation}})
        <p-inputSwitch class="header-switch" [(ngModel)]="tempQtyItem.isActive"></p-inputSwitch>
      </h5>
    </div>
    <div class="card">
      <div class="p-grid">
        <div class="p-col-12 p-md-6">
          <label>Name</label>
          <input type="text" pInputText name="qtyName" [(ngModel)]="tempQtyItem.name">
        </div>
        <div class="p-col-12 p-md-6">
          <label>abbrevation</label>
          <input type="text" pInputText name="qtyAbbrevation" [(ngModel)]="tempQtyItem.abbrevation">
        </div>
      </div>
      <div class="p-grid">
        <div class="p-col-12">
          <label>Location</label>
          <p-dropdown appendTo="body" [options]="qtyTypes" optionLabel="name"
            [ngModelOptions]="{standalone: true}" [(ngModel)]="selectedQtyType" placeholder="Select location">
          </p-dropdown>
        </div>
      </div>
      <div class="p-grid">
        <div class="p-col-12 p-md-2">
          <label style="margin-top: 2.5rem;"></label>
          <p>{{tempQtyItem.abbrevation}}</p>
        </div>
        <div class="p-col-12 p-md-1">
          <label style="margin-top: 2.5rem;"></label>
          <p>=</p>
        </div>
        <div class="p-col-12 p-md-5">
          <label class="p-mt-5"></label>
          <p-dropdown appendTo="body" [options]="allQty" optionLabel="name"
            [ngModelOptions]="{standalone: true}" [(ngModel)]="selectedQty"></p-dropdown>
        </div>
        <div class="p-col-12 p-md-2">
          <label class="p-mt-5"></label>
          <p-dropdown appendTo="body" [options]="allMathSymbol" optionLabel="name"
            [ngModelOptions]="{standalone: true}" [(ngModel)]="selectedMathSymbol"></p-dropdown>
        </div>
        <div class="p-col-12 p-md-2">
          <label style="margin-top: 2.5rem;"></label>
          <span class="btnBars" style="position: relative;">
            <i class="pi pi-trash"></i>
          </span>
          <span class="btnBars" style="position: relative;" (click)="addCalculation()" *ngIf="calculations.length == 0">
            <i class="pi pi-plus"></i>
          </span>
        </div>
      </div>
      <div class="p-grid" *ngFor="let s of calculations;let i = index;">
        <div class="p-col-12 p-md-5 p-offset-3">
          <label class="p-mt-3"></label>
          <p-dropdown appendTo="body" [options]="allQtyItems" optionLabel="name"
            [ngModelOptions]="{standalone: true}" [(ngModel)]="selectedQtyGroup"></p-dropdown>
        </div>
        <div class="p-col-12 p-md-2">
          <label class="p-mt-3"></label>
          <p-dropdown appendTo="body" [options]="allMathSymbol" optionLabel="name"
            [ngModelOptions]="{standalone: true}" [(ngModel)]="selectedMathSymbol"></p-dropdown>
        </div>
        <div class="p-col-12 p-md-2">
          <label class="p-mt-4"></label>
          <span class="btnBars" style="position: relative;" (click)="removeCalculation(i)">
            <i class="pi pi-trash"></i>
          </span>
          <span class="btnBars" style="position: relative;" (click)="addCalculation()"
            *ngIf="calculations.length >= 1 && calculations.length == (i+1)">
            <i class="pi pi-plus"></i>
          </span>
        </div>
      </div>
      <div class="p-grid">
        <div class="p-col-12">
          <label>Description</label>
          <textarea pInputTextarea name="description" [rows]="3" [(ngModel)]="tempQtyItem.description"></textarea>
        </div>
      </div>
    </div>
    <ng-template pTemplate="footer">
      <button pButton (click)="displayAddQtyItem=false;" label="Cancel" class="p-button-secondary"></button>
      <button pButton (click)="saveQtyItem(tempQtyItem)" label="Save"></button>
    </ng-template>
  </p-dialog>
